<template>
    <div class="limit-box">
        <div class="tree-box treeScrollBar">
            <el-input v-model="searchVal" :placeholder="$t('common.inputplaceholder')" prefix-icon="el-icon-search"
                size="medium" style="width: 400px;margin-bottom: 20px;"></el-input>
            <el-tree :data="treeData" ref="tree" show-checkbox node-key="id" default-expand-all
                :expand-on-click-node="false" :props="defaultProps" :filter-node-method="filterNode">
                <div slot-scope="{ node, data }">
                    {{ node.label }}
                    <img src="../../../../assets/icon/channel-config.png" class="sys-channel-icon"
                        @click="openModal(node, data)" v-if="data.type === 'camera'">
                </div>
            </el-tree>
        </div>

        <ChannelModal ref="addModalRef" @saveChannelData="saveChannelData"></ChannelModal>
    </div>
</template>

<script>
import ChannelModal from './channelModal.vue'
export default {
    props: {
        setDisabledAttr: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    components: {
        ChannelModal
    },
    watch: {
        searchVal(val) {
            this.$refs.tree.filter(val);
        }
    },
    data() {
        return {
            searchVal: '',
            roleId: 0,
            treeData: [],
            checkedId: [],
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            actionType: 0, // 0:add 1:detail 2:update
            cameraConfigList: {},
            currentChanneId: null,
        }
    },
    methods: {
        filterNode(value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },
        async initDataList(type, url, cameraConfigList) {
            this.actionType = type;
            this.cameraConfigList = cameraConfigList;
            let res = await this.$Http.get(url);
            if (res.success) {
                let list = res.result;
                if (this.setDisabledAttr) {
                    this.setDisabled(list);
                }
                this.treeData = list;
                let checkedId = [];
                this._setCheckedIds(checkedId, res.result);

                if (this.checkedId.length == 0) {
                    this.$nextTick(() => {
                        this.checkedId = this.getCheckedData();
                    })
                }
                this.$nextTick(() => {
                    this.$refs.tree.setCheckedKeys(checkedId);
                });
            }
        },
        setDisabled(arr) {
            for (var i = 0; i < arr.length; i++) {
                arr[i]['disabled'] = true
                if (arr[i].children && arr[i].children.length > 0) {
                    this.setDisabled(arr[i].children)
                }
            }
        },
        _setCheckedIds(checkedId, res) {
            res.forEach(e => {
                if (e.checked) {
                    checkedId.push(e.id);
                }
                if (e.children != null && e.children.length > 0) {
                    this._setCheckedIds(checkedId, e.children);
                }
            })
        },
        getCheckedData() {
            let checkedKey = this.$refs.tree.getHalfCheckedKeys();
            checkedKey.push(...this.$refs.tree.getCheckedKeys());
            checkedKey = checkedKey.filter(e => e != -1 && e != -2);
            return checkedKey;
        },
        openModal(node, data) {
            this.currentChanneId = data.id.replace('c_', '');
            let channelData = this.cameraConfigList[this.currentChanneId];
            let polygon = {};
            let filterScale = [];
            if (channelData) {
                channelData = JSON.parse(channelData);
                channelData.filterRegion.forEach((item, i) => {
                    polygon[`x${i + 1}`] = item.x;
                    polygon[`y${i + 1}`] = item.y;
                });
                channelData.filterScale.forEach((item, i) => {
                    filterScale.push({
                        timePeriods: [item.beginTime, item.endTime],
                        scale: item.scale
                    })
                });
            }
            this.$refs.addModalRef.open(this.actionType, this.currentChanneId, { pointer: { polygon }, formData: filterScale });
        },
        saveChannelData(data) {
            this.cameraConfigList[this.currentChanneId] = JSON.stringify(data);
            this.$refs.addModalRef.close();
        }
    }
}
</script>

<style scoped lang="scss">
.tree-box {
    // height: 480px;
    // overflow: auto;
    min-height: 200px;
}

.sys-channel-icon {
    width: 14px;
    height: 14px;
    margin-left: 10px;
    cursor: pointer;
    vertical-align: top;
}
::v-deep .el-tree__empty-block {
    height: 200px !important;
}
</style>

<style lang="scss">
.limit-box {
    .el-tree-node.is-current {
        .el-tree-node__content {
            background-color: #fff;
        }
    }
}
</style>